<h2 mat-dialog-title>Assegna manualmente il Lead {{ lead.id }}
  <button mat-icon-button class="close-button" [mat-dialog-close]="null">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  <p *ngIf="lead.province">Scegli a quale consulente assegnare il lead in provincia di {{lead.province.name}}.</p>
  <p>
    <autocomplete [inputControl]="userFormControl" [autocompleteStrategy]="autocompleteUserSuggestionService"
      [label]="'dashboard.agentManager.filter.agent'| translate"
      [placeHolder]="'dashboard.agentManager.filter.agent.placeHolder' | translate" [maxSuggestions]="5"
      [optionImageProvider]="userImageProviderService" (selectedSuggestion)="onSelectedUserSuggestion($event)">
    </autocomplete>
  </p>
</mat-dialog-content>
<mat-dialog-actions align="center">

  <ng-container>
    <button (click)="onCancelClick()" mat-raised-button tabindex="-1">
      Annulla
    </button>
  </ng-container>

  <ng-container>
    <button (click)="onConfirmClick()" color="primary" mat-raised-button tabindex="1">
      Conferma
    </button>
  </ng-container>

</mat-dialog-actions>
